import { useCallback } from "react";
import { money, lineTotalInc } from "../money.js";

export default function CartRow({ item, busy, onUpdateQty, onRemove }) {
	const img = item.images?.[0];
	const name = item.name;
	const variation = item.variation
		?.map((v) => v.value)
		.filter(Boolean)
		.join(" · ");
	const lineTotal = money(lineTotalInc(item), item.totals);
	const qty = item.quantity;
	const maxQty = item.quantity_limits?.maximum ?? 99;
	const minQty = item.quantity_limits?.minimum ?? 1;
	const qtyEditable = item.quantity_limits?.editable !== false;

	const decrement = useCallback(() => {
		if (qty > minQty) onUpdateQty(item.key, qty - 1);
	}, [qty, minQty, item.key, onUpdateQty]);
	const increment = useCallback(() => {
		if (qty < maxQty) onUpdateQty(item.key, qty + 1);
	}, [qty, maxQty, item.key, onUpdateQty]);
	const remove = useCallback(() => onRemove(item.key), [item.key, onRemove]);

	const meta = (item.item_data || []).filter((d) => d.value);

	return (
		<div className={`zc-card zc-row${busy ? " is-busy" : ""}`}>
			<div className="zc-card__top">
				<div className="zc-card__media">
					{img ? (
						<img src={img.thumbnail || img.src} alt={img.alt || name} loading="lazy" />
					) : (
						<div className="zc-card__media-ph" />
					)}
				</div>

				<div className="zc-card__body">
					<span className="zc-card__name">{name}</span>
					{variation && <span className="zc-card__sub">{variation}</span>}
					{meta.length > 0 && (
						<dl className="zc-build__spec">
							{meta.map((d, i) => (
								<div key={i}>
									<dt>{d.key}</dt>
									<dd dangerouslySetInnerHTML={{ __html: d.value }} />
								</div>
							))}
						</dl>
					)}

					{qtyEditable ? (
						<div className="zc-row__qty">
							<button
								className="zc-row__qty-btn"
								onClick={decrement}
								disabled={busy || qty <= minQty}
								aria-label="Decrease quantity"
							>
								&ndash;
							</button>
							<span className="zc-row__qty-val">{qty}</span>
							<button
								className="zc-row__qty-btn"
								onClick={increment}
								disabled={busy || qty >= maxQty}
								aria-label="Increase quantity"
							>
								+
							</button>
						</div>
					) : (
						<span className="zc-row__qty-fixed">Qty {qty}</span>
					)}
				</div>

				<div className="zc-card__aside">
					<span className="zc-card__price">{lineTotal}</span>
					<button
						type="button"
						className="zc-card__remove"
						onClick={remove}
						disabled={busy}
						aria-label={`Remove ${name}`}
					>
						Remove
					</button>
				</div>
			</div>
		</div>
	);
}
